<div class="user-managment-filtering-options">
    <div class="row">
        <div class="col-md-8">
            <div class="filter-by-all-option">
                <div class="form-group align-h">
                    <p class="font-size-16 filter-by-all-label">Filter By</p>
                    <div class="stretch">
                        <mat-form-field class="max-width-200">
                            <mat-select
                                placeholder
                                [(ngModel)]="selectedFilter"
                                name="filer"
                                #filter="ngModel"
                                (selectionChange)="onChangeMainFilter($event)"
                            >
                                <mat-option
                                    *ngFor="let item of filterOptionList"
                                    [value]="item"
                                >
                                    {{ item }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field
                            *ngIf="selectedFilter !== 'All'"
                            class="max-width-200 margin-left-40"
                        >
                            <mat-select
                                [placeholder]="selectedFilter"
                                [(ngModel)]="selectedSubFilter"
                                name="subfiler"
                                #filter="ngModel"
                                (selectionChange)="onChangeSubFilter($event)"
                            >
                                <mat-option
                                    *ngFor="
                    let sFilter of selectedFilter === 'Team'
                      ? teams
                      : ''
                  "
                                    [value]="sFilter"
                                >
                                    {{ sFilter }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="filter-by-name-option">
                <div class="form-group">
                    <mat-form-field>
                        <input
                            placeholder="Search by name or position"
                            matInput
                            [(ngModel)]="searchText"
                            name="search"
                            #search="ngModel"
                        >
                        <mat-icon matSuffix>search</mat-icon>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
    <mat-accordion>
        <mat-expansion-panel
            *ngFor="
        let team of TeamList
          | searchFilter: ['position', 'title']:searchText
      "
            class="margin-bottom-20"
            (opened)="panelMap[team?.id] = true"
            (closed)="panelMap[team?.id] = false"
        >
            <mat-expansion-panel-header class="mat-expansion-panel-header--auto">
                <div class="list-item width-stretch">
                    <div class="list-item-content">
                        <div class="heading margin-bottom-10">
                            <h4 *ngIf="team?.subSectionName !== 'Our Sponsors'">{{ team.position }} |&nbsp; </h4>
                            <span>{{ team.subSectionName }}</span>
                        </div>
                        <p>{{ team.title }}</p>
                    </div>
                    <div class="list-item-action">
                        <ng-template [ngIf]="panelMap[team?.id]">
                            <button
                                mat-icon-button
                                type="button"
                         
                            >
                                <img
                                    src="assets/images/Edit.png"
                                    alt="Edit"
                                    (click)="$event.stopPropagation();teamMemberEdit(team)"
                                >

                            </button>
                            <button
                                mat-icon-button
                                type="button"
                              
                            >
                                <img
                                    src="assets/images/Delete.png"
                                    alt="Delete"
                                    (click)="$event.stopPropagation();openDialog(team)"
                                >
                            </button>
                        </ng-template>
                       
                    </div>
                </div>
            </mat-expansion-panel-header>
            <div class="panel-body">
                <img *ngIf="team?.subSectionName !== 'Our Sponsors'"   [src]="team?.imageUrl" alt="" class="teammember-img">
                <p [innerHTML]="team?.description"></p>
            </div>
           
        </mat-expansion-panel>
    </mat-accordion>
</div>

